import { useMemo } from 'react';
import { BreadcrumbComponentType } from 'use-react-router-breadcrumbs';

import { useBreadcrumbSiteGroupsQuery } from '../../SiteGroups';
import { DynamicBreadcrumbWrapper } from './DynamicBreadcrumbWrapper';

const DynamicSiteGroupsByIdBreadcrumb: BreadcrumbComponentType<'siteGroupId'> = ({ match }) => {
  const siteGroupId = useMemo(() => match.params.siteGroupId ?? '', [match.params.siteGroupId]);

  const breadcrumbQuery = useBreadcrumbSiteGroupsQuery(siteGroupId)();

  return <DynamicBreadcrumbWrapper { ...breadcrumbQuery }/>;
};

const DynamicSiteGroupsListBreadcrumb: BreadcrumbComponentType = () => {
  return <span>Групи Сайтів</span>;
};

export const DynamicSiteGroupsBreadcrumb = {
  DynamicSiteGroupsListBreadcrumb,
  DynamicSiteGroupsByIdBreadcrumb
};
